var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 23,
    viewBox: "0 0 150 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2574 2.40042C24.1282 1.68739 23.7404 1.10875 23.098 0.664503C22.4555 0.220256 21.6268 0 20.6156 0H2.60023L5.18906 2.31456L0 17.1128H5.82011L7.52319 12.2149H16.9091C18.2739 12.2149 19.4637 11.8341 20.4749 11.0726C21.4861 10.311 22.1818 9.39263 22.562 8.31375L24.1092 3.89369C24.2955 3.38598 24.3449 2.88573 24.2536 2.39669L24.2574 2.40042ZM18.0914 4.44619L16.8559 7.96283C16.7723 8.16815 16.6126 8.27268 16.3769 8.27268H8.91834L9.76608 5.86106L7.84252 4.14008H17.8291C17.9887 4.13634 18.08 4.19607 18.1028 4.32673C18.1104 4.37526 18.1066 4.4126 18.0952 4.44619H18.0914Z",
    fill: "#B300B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4689 4.13634H43.455L44.9072 0H23.8849L26.3368 2.19137L22.2198 13.9434C21.6686 15.515 22.9801 17.1128 24.8238 17.1128H38.9122L40.3644 12.9765H28.3783L28.8686 11.5803L27.4279 10.2886H39.9729L41.1855 6.81675H30.5337L30.8872 5.80506L29.0207 4.13634H31.4689V4.12888V4.13634Z",
    fill: "#B300B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2984 1.14235C65.6255 0.380782 64.6067 0 63.2381 0H44.8997L47.5379 2.35562L42.3564 17.1128H48.1842L50.1457 11.5019H52.9703L59.2884 22.9963H65.979L59.0945 11.5019H59.2123C60.8964 11.5019 62.2612 11.1174 63.3028 10.3483C64.3444 9.57929 65.0553 8.66467 65.4392 7.60445L66.7317 3.89742C67.1119 2.81854 66.9674 1.90018 66.2946 1.13861L66.2984 1.14235ZM60.7101 4.44619L59.7293 7.2498C59.6685 7.45512 59.5089 7.55965 59.2504 7.55965H51.5485L52.1377 5.87599L50.199 4.14381H60.4478C60.7063 4.14007 60.7938 4.24087 60.7101 4.44619Z",
    fill: "#B300B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2331 2.40042C88.1038 1.68739 87.7161 1.10875 87.0736 0.664503C86.4312 0.220256 85.6024 0 84.5912 0H66.5759L69.1647 2.31456L63.9756 17.1165H69.7958L71.4988 12.2186H80.8848C82.2495 12.2186 83.4394 11.8379 84.4506 11.0763C85.4618 10.3147 86.1575 9.39637 86.5376 8.31748L88.0848 3.89742C88.2711 3.38971 88.3205 2.88947 88.2293 2.40042H88.2331ZM82.067 4.44619L80.8316 7.96283C80.7479 8.16815 80.5883 8.27268 80.3526 8.27268H72.8978L73.7455 5.86106L71.8182 4.14008H81.8047C81.9644 4.13634 82.0556 4.19607 82.0784 4.32673C82.086 4.37526 82.0822 4.4126 82.0708 4.44619H82.067Z",
    fill: "#E13837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0914 12.9802L97.6418 0H88.4802L91.0234 2.26976L85.8153 17.1128H101.652L103.105 12.9765H93.0914V12.9802Z",
    fill: "#E13837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.096 0H114.901L116.847 1.73965L103.39 17.1128H109.651L117.558 7.8583L119.128 6.02159V6.01412L120.352 12.7711H114.908L119.763 17.1128H127.187L124.096 0Z",
    fill: "#E13837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.058 0L136.368 6.15598L134.19 0H125.655L128.582 2.62068L131.95 11.1248L129.856 17.1128H135.668L137.763 11.1248L150 0H143.058Z",
    fill: "#E13837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOriginal);
export default __webpack_public_path__ + "static/media/logo_original.79f6faea950f8a256ea126fa6a747437.svg";
export { ForwardRef as ReactComponent };